import { IQuoteTemplateData } from '@/models';
import mockAxios, { AxiosResponse } from 'axios';
import {
  IQuoteServiceTemplateServiceMock,
  IQuoteFreightTemplateServiceMock,
  IQuotePaymentTermTemplateServiceMock,
  IQuoteTermTemplateServiceMock,
  IQuoteTemplateServiceMock
} from './quotetemplate.mock.types';

export const mockQuoteTemplateService = <
  T extends IQuoteTemplateData
>(): IQuoteTemplateServiceMock<T> => ({
  fetchQuoteTemplates: jest.fn(),
  fetchQuoteTemplate: jest.fn(),
  createQuoteTemplate: jest.fn(),
  updateQuoteTemplate: jest.fn(),
  deleteQuoteTemplate: jest.fn(),

  // TRANSLATIONS
  fetchQuoteTemplateTranslations: jest.fn(),
  fetchQuoteTemplateTranslation: jest.fn(),
  createQuoteTemplateTranslation: jest.fn(),
  updateQuoteTemplateTranslation: jest.fn(),
  deleteQuoteTemplateTranslation: jest.fn()
});

export const mockQuoteServiceTemplateService = (): IQuoteServiceTemplateServiceMock =>
  mockQuoteTemplateService();
export const mockQuoteFreightTemplateService = (): IQuoteFreightTemplateServiceMock =>
  mockQuoteTemplateService();
export const mockQuotePaymentTermTemplateService = (): IQuotePaymentTermTemplateServiceMock =>
  mockQuoteTemplateService();
export const mockQuoteTermTemplateService = (): IQuoteTermTemplateServiceMock => ({
  ...mockQuoteTemplateService(),
  setQuoteTemplateOrder: jest.fn()
});

export const mockQuoteTemplateAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
